import { Component, Input, OnInit } from '@angular/core';
import { UntypedFormControl, UntypedFormGroup, Validators } from '@angular/forms';

@Component({
  selector: 'lum-channel-form-shopify-creds',
  templateUrl: './channel-form-shopify-creds.component.html',
  styleUrls: ['./channel-form-shopify-creds.component.scss'],
})
export class ChannelFormShopifyCredsComponent implements OnInit {
  @Input() formData :UntypedFormGroup;

  constructor() {}

  ngOnInit() :void {
    this.setControls();
  }

  private setControls() {
    this.formData.addControl(
      'shopify_api_key',
      new UntypedFormControl('', Validators.required),
    );
    this.formData.addControl(
      'shopify_api_secret',
      new UntypedFormControl('', Validators.required),
    );
    this.formData.addControl(
      'shopify_store_url',
      new UntypedFormControl('', Validators.required),
    );
  }
}
